import {OptionProps} from '../components/shared/forms/PPSelect'
import {Nullable} from '../app/TypeHelpers'
import {CodeMasterInterface} from '../CodeMaster'
import {valueStringOrNull} from '../codeMasterHelper/CodeMasterHelper'

export const NoSelectedValue: string = 'none'

export function addEmptyData(data: OptionProps[], emptyItemLabel: string = ''): OptionProps[] {
    return [{label: emptyItemLabel, value: NoSelectedValue}, ...data]
}

export function valueOrNoSelected(target: Nullable<CodeMasterInterface | number>): string {
    if (target === null) {
        return NoSelectedValue
    }
    if (Number.isInteger(target as number)) {
        return `${target}`
    }
    return valueStringOrNull(target as CodeMasterInterface) || NoSelectedValue
}

export function isNoSelect(value: unknown): boolean {
    return `${value}` === NoSelectedValue
}
